export default "__VITE_PUBLIC_ASSET__f0ac837c__"